var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 0a7 7 0 100 14A7 7 0 007 0m0 .583A6.425 6.425 0 0113.417 7 6.425 6.425 0 017 13.417 6.425 6.425 0 01.583 7 6.425 6.425 0 017 .583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 0a7 7 0 100 14A7 7 0 007 0m0 .583A6.425 6.425 0 0113.417 7 6.425 6.425 0 017 13.417 6.425 6.425 0 01.583 7 6.425 6.425 0 017 .583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.208 6.708H7.292v-5.25a.292.292 0 00-.584 0V7c0 .161.131.292.292.292h3.208a.292.292 0 000-.584"
  }))));
}
SvgClockIcon.displayName = 'ClockIcon';
export default SvgClockIcon;